import React, { useRef, useState } from 'react';
import axios from 'axios';
import "./BusinessLocation.css";
import flashMessage from '../HelperFunctions';


function BusinessLocation({ organization, onChange }) {
  const [isSaving, setIsSaving] = useState(false);  // State to handle "saving..." message
  const placeholderText = `123 Main St, San Francisco, CA 94110`;

  const typingTimer = useRef(null);
  const locationInputRef = useRef(null);

  const handleInputChange = (e) => {
    onChange(e.target.value);
  };

  return (

    <div className="customize-ai-section">
      <span>Location</span>
      <input
        data-say-id="knowledge-base-location"
        ref={locationInputRef}
        className="business-location-text"
        placeholder={placeholderText}
        defaultValue={organization.business_location}
        onChange={handleInputChange}
      />

    </div>

  );
}

export default BusinessLocation
